// removed by extract-text-webpack-plugin
module.exports = {"box":"components-yxxc-print-Bdd-fjlyzyxy-index-box-GuoVZ","title":"components-yxxc-print-Bdd-fjlyzyxy-index-title-3rjOc","tableDiv":"components-yxxc-print-Bdd-fjlyzyxy-index-tableDiv-23eOX","tableTitle":"components-yxxc-print-Bdd-fjlyzyxy-index-tableTitle-2b8-_","tableItem":"components-yxxc-print-Bdd-fjlyzyxy-index-tableItem-2tZrM","tableItemPhotoPaste":"components-yxxc-print-Bdd-fjlyzyxy-index-tableItemPhotoPaste-2BWr2","tableItemConfirmTd":"components-yxxc-print-Bdd-fjlyzyxy-index-tableItemConfirmTd-1A4dw","jbxx_icon_bg":"components-yxxc-print-Bdd-fjlyzyxy-index-jbxx_icon_bg-2Ygot"};


//////////////////
// WEBPACK FOOTER
// ./components/yxxc/print/Bdd/fjlyzyxy/index.css
// module id = 2331
// module chunks = 0